export const selectMenuStyle = {
  menu: (baseStyles) => ({
    ...baseStyles,
    zIndex: 200
  })
};

export default selectMenuStyle;
